import type { IntlShape } from "react-intl";

export default function getPageHeadingDetails(intl: IntlShape) {
  return {
    title: intl.formatMessage({
      defaultMessage: "Comunidade Black",
      id: "YlaL/t",
    }),
    description: intl.formatMessage({
      defaultMessage:
        "Crie um tópico abaixo e tire suas dúvidas com os mentores Eduardo e Asvid, além de outros Blacks!",
      id: "MPupJy",
    }),
  };
}
